import Loader from 'components/Loader'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  getIsLoadingAvailability,
  getIsRevenueCentersLoading,
} from 'store/RevenueCenters/selector'
import Section from 'components/Section'
import RevenueCenterItem from './RevenueCenterItem'
import { getIsMenusLoading } from 'store/Menus/selectors'

const RevenueCentersList = ({ revenueCentersList }) => {
  const isLoadingRevenueCenters = useSelector(
    getIsRevenueCentersLoading
  )
  const isLoadingMenus = useSelector(getIsMenusLoading)
  const isLoadingAvailability = useSelector(getIsLoadingAvailability)

  const isLoading =
    isLoadingRevenueCenters || isLoadingMenus || isLoadingAvailability

  if (isLoading) {
    return <Loader />
  }
  return (
    <Section className="item-list">
      {revenueCentersList.map(({ name, uuid, id }) => (
        <RevenueCenterItem name={name} id={id} key={id} uuid={uuid} />
      ))}
    </Section>
  )
}

export default RevenueCentersList
